import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
/* eslint-disable react/jsx-no-useless-fragment */
import { FormProvider, useForm } from "react-hook-form";

// Components
import GameSortAndFilter from "components/organisms/GameSortAndFilter";
import CarouselBannersDesktop from "components/molecules/CarouselBannersDesktop";
import GameFormSearch from "components/molecules/GameFormSearch";
import SkeletonSearchFilterDesktop from "components/molecules/SkeletonSearchFilterDesktop";

// Containers
import GameSortDesktopContainer from "containers/organisms/GameSortDesktopContainer";
import GameSearchListContainer from "containers/molecules/GameSearchListContainer";
import BonusWidgetContainer from "containers/molecules/BonusWidgetContainer";
import BackToGameContainer from "containers/molecules/BackToGameContainer";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import { useLoaderStore } from "stores/loader";
import * as gamesSelector from "redux/game/selectors";
import * as userSelector from "redux/user/selectors";
import { FeatureFlagKeys, useFeatureFlag } from "hooks/useFeatureFlag";
import GameListContainer from "../../../../containers/organisms/GameListContainer";
import { useGetParam } from "../../../../hooks/useGetParam";
import { setCategory } from "../../../../redux/game/slice";

import { CATEGORIES_ENUMS } from "../../../../constants/navigation/categories";

import "./styles.sass";

const HomePage = () => {
  const methods = useForm();
  const { category: categoryQuery } = useGetParam();
  const dispatch = useDispatch();
  const { overlayLoading } = useLoaderStore();
  const { isDesktop } = useBreakpoint();
  const category = useSelector(gamesSelector.category);
  const { id: userId } = useSelector(userSelector.all);
  const backToGameFlag = useFeatureFlag(
    FeatureFlagKeys.BACK_TO_GAME,
    userId ? userId.toString() : "",
  );

  const searchQuery = methods.watch("search");
  useEffect(() => {
    if (categoryQuery) {
      dispatch(setCategory(categoryQuery));
    }
    if (!categoryQuery && category !== CATEGORIES_ENUMS.LOBBY) {
      dispatch(setCategory(CATEGORIES_ENUMS.LOBBY));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryQuery]);

  return (
    <>
      <CarouselBannersDesktop />
      {isDesktop && <BonusWidgetContainer />}
      <FormProvider {...methods}>
        <div className="HomePage">
          <div className="HomePage__header">
            {!isDesktop && <GameSortAndFilter />}
            {isDesktop && (
              <>
                {overlayLoading ? (
                  <SkeletonSearchFilterDesktop />
                ) : (
                  <>
                    <GameFormSearch />
                    <GameSortDesktopContainer />
                  </>
                )}
              </>
            )}
          </div>
          <div className="HomePage__games">
            {searchQuery && searchQuery.length > 0 ? (
              <GameSearchListContainer />
            ) : (
              <GameListContainer />
            )}
          </div>
        </div>
      </FormProvider>
      {backToGameFlag && <BackToGameContainer />}
    </>
  );
};
export default HomePage;
